export const CartIcon = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
    >
      <g clipPath="url(#clip0_31_22)">
        <path
          d="M19.9317 3.33333H3.74167L3.52833 1.7975C3.38667 0.773333 2.5 0 1.465 0H0V0.833333H1.46583C2.08667 0.833333 2.61833 1.29667 2.70333 1.91167L4.3875 14.0358C4.52917 15.06 5.41583 15.8333 6.45083 15.8333H16.6667V15H6.45083C5.83 15 5.29833 14.5367 5.21333 13.9217L5.01583 12.5H18.0983L19.9317 3.33333ZM4.9 11.6667L3.85833 4.16667H18.915L17.415 11.6667H4.9ZM5.83333 16.6667C4.91417 16.6667 4.16667 17.4142 4.16667 18.3333C4.16667 19.2525 4.91417 20 5.83333 20C6.7525 20 7.5 19.2525 7.5 18.3333C7.5 17.4142 6.7525 16.6667 5.83333 16.6667ZM5.83333 19.1667C5.37333 19.1667 5 18.7925 5 18.3333C5 17.8742 5.37333 17.5 5.83333 17.5C6.29333 17.5 6.66667 17.8742 6.66667 18.3333C6.66667 18.7925 6.29333 19.1667 5.83333 19.1667ZM14.1667 16.6667C13.2475 16.6667 12.5 17.4142 12.5 18.3333C12.5 19.2525 13.2475 20 14.1667 20C15.0858 20 15.8333 19.2525 15.8333 18.3333C15.8333 17.4142 15.0858 16.6667 14.1667 16.6667ZM14.1667 19.1667C13.7067 19.1667 13.3333 18.7925 13.3333 18.3333C13.3333 17.8742 13.7067 17.5 14.1667 17.5C14.6267 17.5 15 17.8742 15 18.3333C15 18.7925 14.6267 19.1667 14.1667 19.1667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_31_22">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CartIcon;
